import { __awaiter } from "tslib";
import getValueFromQuery from 'utils/getValueFromQuery';
import waitForOptimizely, { getOptimizelyValue } from 'pathfinder/utils/waitForOptimizely';
import log from 'pathfinder/utils/log';
const SS_PATHFINDER_FORCED_PARAM = 'ss_pathfinder_forced';
/**
 * @deprecated
 * Use moduleConfig.optimizelyActiveVariantId instead
 */
const getOptimizelyVariant = (isForced, optimizelyVariables, variants = {}) => __awaiter(void 0, void 0, void 0, function* () {
    if (isForced) {
        return getValueFromQuery(SS_PATHFINDER_FORCED_PARAM);
    }
    try {
        yield waitForOptimizely();
        if (!getOptimizelyValue(optimizelyVariables.EXPERIMENT_ENABLED)) {
            log.error('Experiment is not enabled');
            return;
        }
        const variant = getOptimizelyValue(optimizelyVariables.EXPERIMENT_VARIANT);
        if (!Object.values(variants).includes(variant)) {
            log.error(`Invalid Optimizely variant: ${variant} (expected one of ${Object.values(variants)})`);
            return;
        }
        return variant;
    }
    catch (error) {
        log.error('Optimizely error', error);
    }
});
export default getOptimizelyVariant;
